import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import DetailItem from '../../components/Program/components/DetailItem';

const TallOuterContainer = styled.div.attrs(({ dynamicHeight }) => ({
  style: { height: `${dynamicHeight}px` }
}))`
  position: relative;
  width: 100%;
`;

const StickyInnerContainer = styled.div`
  position: sticky;
  top: 0;
  height: 100vh;
  width: 100%;
  overflow-x: hidden;
`;

const HorizontalTranslateContainer = styled.div.attrs(({ translateX }) => ({
  style: { transform: `translateX(${translateX}px)` }
}))`
  position: absolute;
  height: 100%;
  will-change: transform;
`;

const CardsContainer = styled.div`
  position:relative;
  height:100%;
  padding: 0 0 0 15px;
  display:flex;
  flex-flow:row nowrap;
  justify-content:flex-start;
  align-items:flex-start;
`

const AmazingScroller = styled.div`
  height:100vw;
  width:100vw;
  overflow:auto;
`

const StyledSliderProgress = styled.span.attrs(({ translateX }) => ({
    style: { transform: `translateX(${translateX}%)` }
  }))`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 0.4rem;
  transform: translateX(-100%);
`

const StyledSlider = styled.div`
  overflow: hidden;
  position: fixed;
  bottom: 5%;
  left: calc(50% - 6.5rem);
  width: 13rem;
  height: 0.4rem;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 0.4rem;
  will-change: transform;
`

const StyledButtonContainer = styled.div`
  position:fixed;
  bottom:15%;
  right:20px;

  @media(max-height:900px){
    bottom:8%;
  }
  @media(max-height:750px){
    bottom:3%;
  }
`

const SideButton = styled.button`
  height:45px;
  width:45px;
  border-radius:50%;
  background-color:white;
  border:none;
  margin:0 5px;

  &:focus{
    outline:none;
  }
`

const ProgressWrapper = styled.div`
  position:relative;
`

const calcDynamicHeight = objectWidth => {
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  let offset = (vw / 2) > 515 ? (vw / 2) : 0;
  return objectWidth - vw + vh + offset;
};

const handleDynamicHeight = (ref, setDynamicHeight) => {
  const objectWidth = ref.current.scrollWidth;
  const dynamicHeight = calcDynamicHeight(objectWidth);
  setDynamicHeight(dynamicHeight);
};

const applyScrollListener = (scrollerRef, setTranslateX, setSliderProgress, dynamicHeight, objectRef) => {
  scrollerRef.current.addEventListener("scroll", () => {
    //objectRef.current.style.transition = "none";
    console.log(objectRef)
    const offsetTop = -scrollerRef.current.scrollTop;
    const vw = window.innerWidth;
    if(dynamicHeight != null){
      const progress = ((-offsetTop / (dynamicHeight - vw)) * 100) - 100;
      setSliderProgress(progress)
    }

    setTranslateX(offsetTop);
  });
};

export default ({ activedate, dataArray, liveSpeakerSlog, withLinkList, smallerImage }) => {
  const [dynamicHeight, setDynamicHeight] = useState(null);
  const [translateX, setTranslateX] = useState(0);
  const [sliderProgress, setSliderProgress] = useState(-100);

  const containerRef = useRef(null);
  const objectRef = useRef(null);
  const scrollerRef = useRef(null);

  const tabChange = () => {
    handleDynamicHeight(objectRef, setDynamicHeight);
  }

  const moveRight = () => {
    const vw = window.innerWidth;
    if(-translateX <= (dynamicHeight - vw)){
      let newPos = translateX - (vw / 3);
      objectRef.current.style.transition = "transform 1.3s linear";
      objectRef.current.getBoundingClientRect();
      setTranslateX(newPos);
    }
  }

  const moveLeft = () => {
    if(translateX < 0){
      const vw = window.innerWidth;
      let newPos = translateX + (vw / 3);
      setTranslateX(newPos);
    }
  }

  const initalizeLivePosition = () => {
    
    setTimeout(() => {
      //const offsetLiveTop = document.getElementById("liveEvent").data("number");
      //setTranslateX(offsetLiveTop);
    }, 400)
  }

  useEffect(() => {
    const resizeHandler = () => {
      handleDynamicHeight(objectRef, setDynamicHeight);
    };

    handleDynamicHeight(objectRef, setDynamicHeight);
    window.addEventListener("resize", resizeHandler);

    //initalizeLivePosition();

    return() => {
      window.removeEventListener("resize", resizeHandler);
    }

  }, [activedate]);

  useEffect(() => {
    applyScrollListener(scrollerRef, setTranslateX, setSliderProgress, dynamicHeight, translateX, objectRef);
  }, [dynamicHeight])


  // useEffect(() => {
  //   tabChange();
  // }, [activedate])

  return ( 
    <ProgressWrapper>
      <AmazingScroller ref={scrollerRef}>
        <TallOuterContainer dynamicHeight={dynamicHeight}>
          <StickyInnerContainer ref={containerRef}>
            <HorizontalTranslateContainer translateX={translateX} ref={objectRef}>
              <CardsContainer id="itemContainer">
                {dataArray.map((speaker, index) => {
                  return(
                    <DetailItem
                      key={speaker.node.slug}
                      linkList={withLinkList}
                      liveSpeakerSlug={liveSpeakerSlog}
                      index={index}
                      speakerKey={speaker.node.slug}
                      Url={"/speaker/" + speaker.node.slug}
                      time={speaker.node.time}
                      title={speaker.node.title}
                      speakerName={speaker.node.speakerName}
                      companyName={speaker.node.companyName}
                      image={speaker.node.image}
                      onFoundLive={initalizeLivePosition}
                      smallerImage={smallerImage}
                    ></DetailItem>
                )})}
              </CardsContainer>
            </HorizontalTranslateContainer>
          </StickyInnerContainer>
        </TallOuterContainer>
      </AmazingScroller>
      <StyledSlider><StyledSliderProgress translateX={sliderProgress}></StyledSliderProgress></StyledSlider>
      <StyledButtonContainer>
      <SideButton onClick={moveLeft}>
      {`<`}
      </SideButton>
      <SideButton onClick={moveRight}>
      {`>`}
      </SideButton>
      </StyledButtonContainer>
    </ProgressWrapper>
  );
};
